import React, { FC, useEffect, useState } from 'react';
import SimpleModal from '../Modal/SimpleModal';
import ModalWithTitleInner from '../Modal/ModalWithTitleInner';
import Image from 'common/components/Image';
import { useAccount } from 'wagmi';
import { useConnectModal } from '@rainbow-me/rainbowkit';

const InitialWalletModal: FC = () => {
  const [open, setOpen] = useState<boolean>(true);

  const { isConnected } = useAccount();
  const { openConnectModal } = useConnectModal();

  useEffect(() => {
    if (isConnected) {
      setOpen(false);
    }
  }, [isConnected]);

  return (
    <SimpleModal overflowVisible isShowing={open}>
      <ModalWithTitleInner
        title="Connect Wallet"
        hasCloseButton={true}
        hide={() => setOpen(false)}
      >
        <div className="flex flex-col items-center">
          <Image
            src="https://ichi-images.s3.amazonaws.com/misc/wallet.svg"
            alt="Connect Wallet"
            className="w-16"
          />
          <div className="text-center p-6">
            You are not currently connected to your wallet. Please connect now.
          </div>
          {openConnectModal && (
            <button
              onClick={openConnectModal}
              className="primary-button-bg-color text-white font-semibold py-[10px] px-7 rounded-[10px] max-w-[188px]"
            >
              Connect Wallet
            </button>
          )}
        </div>
      </ModalWithTitleInner>
    </SimpleModal>
  );
};

export default InitialWalletModal;
